function EmptyState({ headingText, bodyText, action = null }) {
  return (
    <div className='d-flex justify-content-center align-items-center bg-white p-5 rounded mt-2'>
      <div className='d-flex flex-column align-items-center gap-3 text-center'>
        <span className='fs-5'>
          <b>{headingText}</b>
        </span>
        <span>{bodyText}</span>
        {action}
      </div>
    </div>
  );
}

export default EmptyState;
